import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { SkillTag } from 'redux/schemas/models/skill-tag';

export const getSkillTags = createAsyncThunk(
  'GET_SKILL_TAGS',
  getTags,
);

export const addSkillTag = createAsyncThunk(
  'ADD_SKILL_TAG',
  addTag,
);

export const deleteSkillTag = createAsyncThunk(
  'DELETE_SKILL_TAG',
  deleteTag,
);

export const tagLectureComponent = createAsyncThunk(
  'TAG_LECTURE_COMPONENT',
  addTagToLectureComponent,
);
export const removeTagLectureComponent = createAsyncThunk(
  'REMOVE_TAG_LECTURE_COMPONENT',
  removeTagFromLectureComponent,
);

// export type SkillTagsDataParams = SkillTagParams;

export type AdminParams = { institutionId: number, tag?: SkillTag };
export type TagParams = { catalogId: string, lecturePageId: number, lectureComponentId: number, lectureComponentName: string, skillTagId: number };


async function getTags(params: AdminParams) {
  return axios.get(`/institutions/${params.institutionId}/skill_tags.json`).then((response) => response.data.result);
}

async function addTag(params: AdminParams, { rejectWithValue }) {
  try {
    const response = await axios.post(`/institutions/${params.institutionId}/skill_tags.json`, {
      name: params.tag.name,
    }).then((postresponse) => postresponse.data.result);
    return response;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
}

async function deleteTag(params: AdminParams) {
  return axios.delete(`institutions/${params.institutionId}/skill_tags/${params.tag.id}.json`).then((response) => response.data);
}

async function addTagToLectureComponent(params: TagParams) {
  return axios.post(`/${params.catalogId}/lecture_pages/${params.lecturePageId}/${params.lectureComponentName}/${params.lectureComponentId}/skill_tags.json`,
    { skill_tag_id: params.skillTagId }).then((response) => response.data.result);
}

async function removeTagFromLectureComponent(params: TagParams) {
  return axios.delete(`/${params.catalogId}/lecture_pages/${params.lecturePageId}/${params.lectureComponentName}/${params.lectureComponentId}/skill_tags/${params.skillTagId}.json`)
  .then((response) => response.data.result);
}
